module.exports = __webpack_public_path__ + "closedhand.a8c874b93b3d848f39a7.cur";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/revolution/css/closedhand.cur
// module id = ../../../../../src/assets/revolution/css/closedhand.cur
// module chunks = styles